"use client";

import styles from "./Upcomingcategories.module.css";

const UPCOMING = [
  {
    emoji: "🛒",
    name: "Grocery",
    desc: "Fresh daily essentials & pantry staples",
    color: "#22c55e",
    bg: "rgba(34,197,94,0.09)",
  },
  {
    emoji: "📱",
    name: "Electronics",
    desc: "Gadgets, devices & smart tech",
    color: "#3b82f6",
    bg: "rgba(59,130,246,0.09)",
  },
  {
    emoji: "👗",
    name: "Fashion",
    desc: "Trendy clothing & accessories",
    color: "#ec4899",
    bg: "rgba(236,72,153,0.09)",
  },
//   {
//     emoji: "🥐",
//     name: "Bakery Items",
//     desc: "Freshly baked breads & pastries",
//     color: "#f59e0b",
//     bg: "rgba(245,158,11,0.09)",
//   },
  {
    emoji: "🌿",
    name: "Organic Foods",
    desc: "100% natural & farm-fresh produce",
    color: "#10b981",
    bg: "rgba(16,185,129,0.09)",
  },
];

const UpcomingCategories = () => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>

        {/* ── Header ── */}
        <div className={styles.header}>
          <div className={styles.badge}>
            <span className={styles.badgeDot} />
            Coming Soon
          </div>
          <h2 className={styles.title}>
            Upcoming{" "}
            <span className={styles.titleAccent}>Categories</span>
          </h2>
          <p className={styles.subtitle}>
            Exciting new categories are on their way — stay tuned!
          </p>
          <div className={styles.underline} />
        </div>

        {/* ── Cards ── */}
        <div className={styles.grid}>
          {UPCOMING.map((cat) => (
            <div
              key={cat.name}
              className={styles.card}
              style={{
                "--card-color": cat.color,
                "--card-bg": cat.bg,
              } as React.CSSProperties}
            >
              <span className={styles.ribbon}>Soon</span>
              <div className={styles.iconWrap}>{cat.emoji}</div>
              <h3 className={styles.cardName}>{cat.name}</h3>
              <p className={styles.cardDesc}>{cat.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default UpcomingCategories;